module.exports = __webpack_public_path__ + "img/c324c3f21c363ae8e7fcaff4f8c8e5e6.png";